import React from 'react';
import PropTypes from 'prop-types';

// sushi
import Modal from 'sushiweb/Modal';
import grey from 'sushiweb/tokens/color/grey';

// components
import CreateProgramModalContext from './CreateProgramModalContext';
import VoucherProgramForm from './ProgramForms/VoucherProgramForm/VoucherProgramForm';
import { MEAL_PLAN } from './ProgramForms/common/Components/constants';

function CreateProgramModal({
  title,
  showModal,
  closeModal,
  modalClose,
  changeTitle,
  planData,
  planDataFlag,
}) {
  const renderModalBody = render => {
    switch (render) {
      case MEAL_PLAN:
        return (
          <VoucherProgramForm planData={planData} planDataFlag={planDataFlag} />
        );
      default:
        return <div>Plan Form not available</div>;
    }
  };
  const modalTitle = planDataFlag ? title : 'Create new meal plan';
  // jsx
  return (
    <Modal
      title={
        <span
          style={{
            fontSize: '20px',
            fontWeight: 500,
            color: grey.z800,
            paddingLeft: '6px',
          }}
        >
          {modalTitle}{' '}
        </span>
      }
      visible={showModal}
      onClose={closeModal}
      showCloseIcon
      isCentered
    >
      <CreateProgramModalContext.Provider
        value={{ closeModal, modalClose, changeTitle }}
      >
        {/* need to to dismount the body on close */}
        {showModal && renderModalBody(title)}
      </CreateProgramModalContext.Provider>
    </Modal>
  );
}

CreateProgramModal.propTypes = {
  title: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalClose: PropTypes.object.isRequired,
  changeTitle: PropTypes.object.isRequired,
  planData: PropTypes.objectOf(PropTypes.any),
  planDataFlag: PropTypes.bool,
};

CreateProgramModal.defaultProps = {
  planData: {},
  planDataFlag: false,
};

export default CreateProgramModal;
